import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { extractEntregaIdFromQrText } from '../../utils/assignDeliveryHelpers';
import { scrollQrReaderIntoView, startAssignDeliveryHtml5Reader } from '../../utils/assignDeliveryScanner';

const READER_LANDING_ID = 'assign-delivery-landing-qr-reader';

/**
 * Tela inicial para usuários somente leitor de QR (sem acesso ao restante do painel).
 */
function AssignDeliveryLanding({ authorized, handleLogout }){
	const history = useHistory();
	const location = useLocation();
	const [scanning, setScanning] = useState(false);
	const html5QrRef = useRef(null);
	const autoScanStartedRef = useRef(false);

	useEffect(() => () => {
		if(html5QrRef.current){
			html5QrRef.current.stop().catch(() => {}).finally(() => {
				html5QrRef.current = null;
			});
		}
	}, []);

	const pararScanner = () => {
		if(html5QrRef.current){
			html5QrRef.current.stop().catch(() => {}).finally(() => {
				html5QrRef.current = null;
			});
		}
		setScanning(false);
	};

	const iniciarScanner = () => {
		if(scanning) return;
		setScanning(true);
		window.setTimeout(async () => {
			if(!document.getElementById(READER_LANDING_ID)){
				setScanning(false);
				return;
			}
			try{
				const { html5 } = await startAssignDeliveryHtml5Reader(
					READER_LANDING_ID,
					async (decodedText, html5) => {
						try {
							await html5.stop();
						}catch(_e){ /* noop */ }
						html5QrRef.current = null;
						setScanning(false);
						const id = extractEntregaIdFromQrText(decodedText);
						if(!id){
							window.alert('Código inválido. Escaneie o QR da etiqueta (link ou ID de 24 caracteres).');
							return;
						}
						history.push(`/assign-delivery/${id}`);
					},
					() => {}
				);
				html5QrRef.current = html5;
				scrollQrReaderIntoView(READER_LANDING_ID);
			}catch(_err){
				html5QrRef.current = null;
				setScanning(false);
				window.alert('Não foi possível usar a câmera. Peça o link ao expedidor ou abra o link do QR no navegador.');
			}
		}, 260);
	};

	useEffect(() => {
		if(autoScanStartedRef.current) return;
		if(!location.state || !location.state.openScanner) return;
		autoScanStartedRef.current = true;
		history.replace('/assign-delivery');
		window.setTimeout(iniciarScanner, 150);
	}, [location.state, history]);

	return (
		<div className="assignDelivery assignDelivery-landing">
			<div className="assignDelivery-card">
				<h1 className="assignDelivery-titulo">Leitor de QR — atribuir lote</h1>
				<p className="assignDelivery-lead">
					Escaneie o código da etiqueta da entrega ou use o link que o expedidor enviar.
					Com ele você acessa a tela para escanear outras etiquetas e confirmar o motorista.
				</p>
				<p className="assignDelivery-msg">Esta conta não tem acesso às demais telas do sistema.</p>

				<div className="assignDelivery-landingAcoes">
					{ scanning ? (
						<>
							<div id={READER_LANDING_ID} className="assignDelivery-reader" />
							<button type="button" className="assignDelivery-btnSec" onClick={pararScanner}>
								Cancelar câmera
							</button>
						</>
					) : (
						<button type="button" className="assignDelivery-btnPri" onClick={iniciarScanner}>
							Escanear código QR
						</button>
					) }
					{ authorized ? (
						<button type="button" className="assignDelivery-btnOutline" onClick={() => handleLogout()}>
							Sair
						</button>
					) : (
						<Link to="/login" className="assignDelivery-btnOutline assignDelivery-loginLink">Entrar</Link>
					) }
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	authorized: state.auth.authorized
});

export default connect(mapStateToProps, actions)(AssignDeliveryLanding);
